function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCake(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 48 48",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Cake") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("rect", {
    id: "_36---Cake",
    x: 0,
    y: 0,
    width: 48,
    height: 48,
    style: {
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.332,14.479c0,3.69 -4.032,6.965 -10.24,8.996",
    style: {
      fill: "none",
      stroke: "#444f58",
      strokeWidth: 2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18,25.637c-4.632,0 -8.973,-0.561 -12.697,-1.539",
    style: {
      fill: "none",
      stroke: "#444f58",
      strokeWidth: 2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.027,3.018c2.221,-0.271 4.559,-0.416 6.973,-0.416c1.845,0 3.645,0.085 5.383,0.246",
    style: {
      fill: "none",
      stroke: "#444f58",
      strokeWidth: 2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.742,3.831c8.646,1.923 14.59,5.903 14.59,10.496l0,10.195c0,0.658 -0.29,1.282 -0.794,1.706c-0.503,0.423 -1.168,0.603 -1.816,0.491c-0.524,-0.091 -1.07,-0.185 -1.581,-0.274c-1.428,-0.247 -2.89,0.189 -3.95,1.178c0,0.001 0,0.001 0,0.001c-3.088,2.884 -11.921,4.065 -17.686,4.123c-4.297,0.043 -5.618,-0.841 -8.134,-1.936c0,0 -2.67,2.672 -5.028,5.672c-1.685,2.143 -3.538,1.531 -4.552,0.239c-1.508,-1.921 -2.106,-6.403 -3.366,-7.213c-1.485,-0.954 -2.963,-1.904 -4.05,-2.603c-1.064,-0.684 -1.707,-1.862 -1.707,-3.127c0,-3.048 0,-8.452 0,-8.452c0,-3.943 4.38,-7.434 11.09,-9.56",
    style: {
      fill: "none",
      stroke: "#444f58",
      strokeWidth: 2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.058,16.536l0,7.704c0,6.158 -11.228,11.158 -25.058,11.158c-11.627,0 -21.415,-3.534 -24.238,-8.319c-0.535,-0.906 -0.82,-1.858 -0.82,-2.839l0,-8.675",
    style: {
      fill: "none",
      stroke: "#444f58",
      strokeWidth: 2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.822,11.94l0.182,1.82",
    style: {
      fill: "none",
      stroke: "#444f58",
      strokeWidth: 2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.689,15.762l-1.092,-1.456",
    style: {
      fill: "none",
      stroke: "#444f58",
      strokeWidth: 2
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 21.714,
    cy: 11.94,
    r: 2.519,
    style: {
      fill: "none",
      stroke: "#444f58",
      strokeWidth: 2
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 29.383,
    cy: 9.501,
    r: 1.349,
    style: {
      fill: "none",
      stroke: "#444f58",
      strokeWidth: 2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.383,6.152c0,0 -0.697,-3.546 1.958,-5.387",
    style: {
      fill: "none",
      stroke: "#444f58",
      strokeWidth: 2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.582,9.534c0,0 0.066,-7.932 -8.237,-9.534",
    style: {
      fill: "none",
      stroke: "#444f58",
      strokeWidth: 2
    }
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCake);
export default __webpack_public_path__ + "static/media/cake.654acac28d295e546d69a970791dc576.svg";
export { ForwardRef as ReactComponent };